import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import { transformResultsToCompProfileData } from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function Innovation({ susFinInnoRisk = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // {
        //   key: "supply_chain_digitalization",
        //   label: "Supply Chain Digitalization",
        // },
        {
          key: "R & D_spend_pct_revenue",
          label: "R & D Spend (% Revenue)",
        },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // {
        //   key: "supply_chain_digitalization",
        //   label: "Supply Chain Digitalization",
        // },
        {
          key: "automation_initiatives",
          label: "Automation Initiatives",
        },
        {
          key: "R & D_spend_pct_revenue",
          label: "R & D Spend (% Revenue)",
        },
        {
          key: "benchmarking_vs_industry",
          label: "Benchmarking vs Industry",
        },
        {
          key: "forward_outlook",
          label: "Forward Outlook",
        },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const dataArray = Array.isArray(susFinInnoRisk)
      ? susFinInnoRisk
      : [susFinInnoRisk];

    const cleanedData = dataArray.map((item) => {
      const { sustainability, finance, risks, ...rest } = item.response || {};
      return { ...item, response: rest };
    });

    const transformed = transformResultsToCompProfileData(cleanedData);
    setTabData(transformed);

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={susFinInnoRisk?.[0]?.response?.tableComments || ""}
      />
    );
  }, [susFinInnoRisk]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Innovation"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="supply_chain_digitalization"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default Innovation;
